import api from "@/services/api";

const { post } = api.getPrefixedMethods("email");

export const emailService = {
  postSendOutgoingEmail(
    {
      subject,
      body,
      toEmails,
      templateId,
      fileLinks,
      attachment,
      orderInfoKey,
      intakeOrderId,
      intakeDocumentKey,
      appeal,
      appealId,
      appealAttachmentLinks,
      excludedEnclosureLinks,
      excludedEnclosurePages,
      coverSheetText,
      previewOnly,
      missingInformationRequest,
    },
    config
  ) {
    const data = { subject, body, toEmails, fileLinks };
    if (templateId) {
      data.templateId = templateId;
    }
    if (attachment) {
      data.attachment = attachment;
    }
    if (orderInfoKey) {
      data.orderInfoKey = orderInfoKey;
    }
    if (intakeOrderId) {
      data.intakeOrderId = intakeOrderId;
    }
    if (intakeDocumentKey) {
      data.intakeDocumentKey = intakeDocumentKey;
    }
    if (appeal) {
      data.appeal = true;
      data.appealAttachmentLinks = appealAttachmentLinks ?? [];
      data.excludedEnclosureLinks = excludedEnclosureLinks ?? [];
      data.excludedEnclosurePages = excludedEnclosurePages ?? [];
      data.coverSheetText = coverSheetText ?? "";
    }
    if (appealId) {
      data.appealId = appealId;
    }
    if (previewOnly) {
      data.previewOnly = true;
    }
    if (missingInformationRequest) {
      data.missingInformationRequest = true;
    }
    return post(`send-outgoing-email/`, data, config);
  },
};
